<script setup>
import '@campact/camper/core/CmprButton';
import csrfToken from '@cta/shared/csrf';
import CmprModal from '@cta/frontend/components/CmprModal.vue';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  owner: {
    type: String,
    default: undefined,
  },
  iban: {
    type: String,
    default: undefined,
  },
  allowPath: {
    type: String,
    default: undefined,
  },
  forbidPath: {
    type: String,
    default: undefined,
  },
  redirectUrl: {
    type: String,
    default: undefined,
  },
  analyticsIdPrefix: {
    type: String,
    default: 'donate-call',
  },
  consentText: {
    type: String,
    default: '',
  },
});

function redirect() {
  document.location = props.redirectUrl;
}
</script>

<template>
  <CmprModal
    class="prefill-bankaccount-modal"
    :visible="visible"
    @update:visible="redirect"
  >
    <template #content>
      <h2>
        Spende weiterhin sicher – nur schneller
      </h2>
      <p>
        {{ consentText }}
      </p>
    </template>

    <template #footer>
      <form
        :action="allowPath"
        method="post"
      >
        <input
          name="authenticity_token"
          type="hidden"
          :value="csrfToken()"
        >
        <input
          name="owner"
          type="hidden"
          :value="owner"
        >
        <input
          name="iban"
          type="hidden"
          :value="iban"
        >
        <cmpr-button
          class="w-100"
          :data-analytics-id="`${analyticsIdPrefix}-form-prefill-bankaccount-overlay-allow-button`"
          size="small"
          type="submit"
          variant="secondary"
        >
          Ja, ich möchte sicher und schneller spenden
        </cmpr-button>
      </form>

      <form
        :action="forbidPath"
        method="post"
      >
        <input
          name="authenticity_token"
          type="hidden"
          :value="csrfToken()"
        >
        <cmpr-button
          class="w-100"
          :data-analytics-id="`${analyticsIdPrefix}-form-prefill-bankaccount-overlay-forbid-button`"
          size="small"
          type="submit"
          variant="tertiary"
        >
          Nein, ich möchte meine Daten immer neu eintippen
        </cmpr-button>
      </form>
    </template>
  </CmprModal>
</template>
